export const DEFAULT_TITLE = 'Заявка отправлена!';
export const DEFAULT_HELPER_TEXT = 'Ожидайте звонка от риелторов в течение 15 часов.';
export const ADDITIONAL_TEXT = `Если вам не позвонят мы перенаправим вашу заявку другим подходящим риелторам и они с вами свяжутся в течение 7 дней.`;
